import { render } from "./SideBarHeader.vue?vue&type=template&id=4986d5ae&scoped=true"
import script from "./SideBarHeader.vue?vue&type=script&lang=js"
export * from "./SideBarHeader.vue?vue&type=script&lang=js"

import "./SideBarHeader.vue?vue&type=style&index=0&id=4986d5ae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4986d5ae"]])

export default __exports__